import React from 'react'

import {
  CheckCircleFilled,
  CloseCircleFilled,
  DeleteFilled,
  ExclamationCircleFilled,
  InfoCircleFilled,
  QuestionCircleFilled,
  WarningFilled
} from '@ant-design/icons'

import Modal from 'antd/es/modal'

// Custom Trash Icon Component
const CustomTrashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="49" height="64" viewBox="0 0 49 64" fill="none">
    <path d="M48.5231 20.5477H18.9224L32.178 7.29212C32.9103 6.55989 32.9103 5.37268 32.178 4.64032L28.8191 1.28143C27.1106 -0.427143 24.3404 -0.427143 22.6317 1.28143L19.1781 4.7352L17.4101 2.96725C15.4607 1.01769 12.2884 1.01781 10.3388 2.96725L3.4443 9.86179C1.49474 11.8113 1.49474 14.9836 3.4443 16.9332L5.21212 18.7011L1.75848 22.1548C0.0499079 23.8633 0.0499079 26.6335 1.75848 28.3422L5.11738 31.7011C5.84948 32.4333 7.03682 32.4335 7.76904 31.7011L12.5215 26.9486V55.8747C12.5215 60.3622 16.1594 64.0001 20.6469 64.0001H40.3978C44.8853 64.0001 48.5231 60.3622 48.5231 55.8747V20.5477ZM7.86391 16.0492L6.0961 14.2814C5.60874 13.794 5.60874 13.0009 6.0961 12.5135L12.9906 5.61892C13.4781 5.13143 14.2712 5.13156 14.7584 5.61892L16.5263 7.38686L7.86391 16.0492ZM24.055 53.4995C24.055 54.5351 23.2156 55.3746 22.18 55.3746C21.1444 55.3746 20.3049 54.5351 20.3049 53.4995V31.0483C20.3049 30.0127 21.1444 29.1732 22.18 29.1732C23.2156 29.1732 24.055 30.0127 24.055 31.0483V53.4995ZM32.3974 53.4995C32.3974 54.5351 31.5579 55.3746 30.5223 55.3746C29.4867 55.3746 28.6473 54.5351 28.6473 53.4995V31.0483C28.6473 30.0127 29.4867 29.1732 30.5223 29.1732C31.5579 29.1732 32.3974 30.0127 32.3974 31.0483V53.4995ZM40.7398 53.4995C40.7398 54.5351 39.9003 55.3746 38.8647 55.3746C37.8291 55.3746 36.9896 54.5351 36.9896 53.4995V31.0483C36.9896 30.0127 37.8291 29.1732 38.8647 29.1732C39.9003 29.1732 40.7398 30.0127 40.7398 31.0483V53.4995Z" fill="black" fillOpacity="0.15"/>
    <path d="M32.611 14.193C32.0544 14.3874 31.5639 14.7351 31.1962 15.1959C30.8284 15.6568 30.5982 16.2122 30.5322 16.7981H48.5232V13.6817C48.5232 11.5419 46.4176 10.036 44.3955 10.7216L32.6499 14.1805C32.6373 14.1841 32.6235 14.1891 32.611 14.193Z" fill="black" fillOpacity="0.15"/>
  </svg>
)

export const showSuccessModal = (props = {}) =>
  Modal.success({
    className: 'ant-dialog-modal-v5',
    centered: true,
    content: 'Action is successful.',
    title: 'Success',
    width: 350,
    icon: <CheckCircleFilled className="modal-warning-icon" />,
    ...props
  })
export const showErrorModal = (props) =>
  Modal.error({
    className: 'ant-dialog-modal-v5',
    width: 350,
    title: 'Error',
    icon: <CloseCircleFilled className="modal-warning-icon" />,
    ...props
  })

export const showInfoModal = (props = {}) =>
  Modal.info({
    className: 'ant-dialog-modal-v5',
    width: 350,
    title: 'Information',
    icon: <InfoCircleFilled className="modal-warning-icon" />,
    ...props
  })

export const showConfirmModal = (props = {}) =>
  Modal.confirm({
    className: 'ant-dialog-modal-v5',
    centered: true,
    content: 'Are you sure you want to proceed?',
    icon: <QuestionCircleFilled className="modal-warning-icon" />,
    title: 'Confirm action',
    width: 350,
    okButtonProps: { type: 'danger' },
    ...props
  })

export const showConfirmDeleteModal = (props) => {
  const { className, ...restProps } = props;
  const combinedClassName = className 
    ? `ant-dialog-modal-v5 ${className}` 
    : 'ant-dialog-modal-v5';
    
  return showConfirmModal({
    width: 303,
    icon: <></>,
    okButtonProps: { type: 'danger' },
    okText: 'Delete',
    cancelText: 'Cancel',
    className: combinedClassName,
    ...restProps
  });
}

export const showCancelModal = (props = {}) =>
  Modal.confirm({
    className: 'ant-dialog-modal-v5',
    centered: true,
    content: 'Are you sure you want to proceed?',
    icon: <ExclamationCircleFilled className="modal-warning-icon" />,
    okButtonProps: { type: 'danger' },
    title: 'Confirm action',
    width: 350,
    ...props
  })

export const showModalCancelModal = (props = {}) =>
  Modal.confirm({
    className: 'ant-dialog-modal-v5',
    centered: true,
    content:
      'Closing this window will discard all unsaved changes. Are you sure you want to proceed?',
    icon: <WarningFilled className="modal-warning-icon" />,
    okButtonProps: { type: 'danger' },
    title: 'Confirm action',
    width: 350,
    ...props
  })
